/**
 *
 * CountrySelect
 *
 */
import React, { memo } from 'react';

import { useTranslation } from 'react-i18next';
import { Control, Controller, UseFormSetValue } from 'react-hook-form';

import { PreloadedQuery, useFragment, usePreloadedQuery } from 'react-relay';
import { countryCountriesQuery } from 'services/country/__generated__/countryCountriesQuery.graphql';
import { countryCountriesFragment$key } from 'services/country/__generated__/countryCountriesFragment.graphql';
import { COUNTRIES_FRAGMENT, COUNTRIES_QUERY } from 'services/country/country.relay.services';

import { ButtonStyled } from 'app/components/ButtonStyled';
import { FormHeader, FormButtonContainer } from 'app/components/MultiStepForm/styles';

import { SelectStyled } from 'app/components/SelectStyled';

interface Props {
  control: Control<any, any>;
  setValue?: UseFormSetValue<any>;
  countriesQueryRef: PreloadedQuery<countryCountriesQuery>;
  label?: string;
  title?: string;
  next?: () => void;
}

export const CountrySelect = memo(({ title, next, control, setValue, countriesQueryRef }: Props) => {
  const { t } = useTranslation();

  const countriesQuery = usePreloadedQuery(COUNTRIES_QUERY, countriesQueryRef);
  const countriesQueryData = useFragment<countryCountriesFragment$key>(
    COUNTRIES_FRAGMENT,
    countriesQuery.countries.edges as any,
  );
  const countriesData = countriesQueryData.map(edge => {
    const { id, name } = edge?.node!;
    return {
      label: name,
      value: id,
    };
  });

  return (
    <>
      {title && <FormHeader>{title}</FormHeader>}
      <Controller
        control={control}
        name="countryId"
        render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
          <>
            <SelectStyled
              label={t('auth.sign_up_invite.country_select.label')}
              isSearchable={true}
              width="100%"
              name="countryId"
              variant="primary"
              options={countriesData}
              onChange={selectedOption => {
                onChange(selectedOption.value);
                setValue?.('country', selectedOption.label);
              }}
              onBlur={onBlur}
              value={value}
              placeholder={t('auth.sign_up_invite.country_select.placeholder')}
              height="48px"
              mb={6}
            />
            {next && (
              <FormButtonContainer mt={6}>
                <ButtonStyled variant="primary" minWidth="90px" onClick={next} disabled={!value || !!error}>
                  {t('auth.button.continue')}
                </ButtonStyled>
              </FormButtonContainer>
            )}
          </>
        )}
      />
    </>
  );
});
